import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

export const useStyles = makeStyles((theme: Theme) => {
    return {
        headerText: {
            fontSize: "20px",
            fontWeight: 700,
            textAlign: "center",
        },
        headerTextWidthPadding: {
            fontSize: "20px",
            fontWeight: 700,
            textAlign: "center",
            padding: "0 12px",
            width: "20%",
        },
        firstColumnText: {
            fontSize: "17px",
            fontWeight: 400,
            color: "#7c7c7c",
        },
        regularColumnText: {
            fontSize: "17px",
            fontWeight: 400,
            color: "#000",
        },
        borderBottomContentRow: {
            borderBottom: "1px solid #7C7C7C50",
        },
    };
});
